// @flow

import { type OneClickCard } from '@tectonics/prs/one-click-card/types';
import { translate } from '@tectonics/translate';
import { capitalize } from '@tectonics/commons/string';

export function formatOneClickCardInfoLabel(oneClickCard: OneClickCard): string {
  return translate('volcanes.payment-methods.card.oneClick.cardInfoLabel', {
    brand: capitalize(oneClickCard.brand),
    lastFour: oneClickCard.last_four,
  });
}
